(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boat-fitment-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boat-fitment-finder')) {
    customElements.define('boat-fitment-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.search = this.querySelector('[data-fitment-search]');
        this.count = this.querySelector('[data-fitment-count]');
        this.empty = this.querySelector('[data-fitment-empty]');
        this.makeSelect = this.querySelector('[data-fitment-make]');
        this.modelSelect = this.querySelector('[data-fitment-model]');
        this.yearSelect = this.querySelector('[data-fitment-year]');
        this.go = this.querySelector('[data-fitment-go]');
        this.grid = this.querySelector('.pbf__grid');
        this.sentinel = this.querySelector('[data-fitment-sentinel]');
        this.letterButtons = Array.from(this.querySelectorAll('[data-fitment-letter]'));
        this.activeLetter = 'all';
        this.overrides = Array.from(this.querySelectorAll('[data-fitment-record]')).map((record) => ({ ...record.dataset }));
        this.overrideByMake = new Map(this.overrides.map((record) => [record.makeKey, record]));
        this.collectionUnavailable = new Set(['carrera', 'excalibur', 'mach-1', 'scarab', 'scarab-jet-boat', 'sea-doo', 'solo-skiff', 'spear', 'yamaha']);
        this.brands = this.readCatalog();
        this.productRecords = this.readProductCatalog();
        this.batchSize = 30;
        this.renderedCount = 0;
        this.renderCatalog();
        this.records = this.productRecords.length ? this.productRecords : this.brands.map((brand) => this.recordForBrand(brand));
        this.search?.addEventListener('input', () => {
          this.ensureAllRendered();
          this.filter();
        });
        this.makeSelect?.addEventListener('change', () => this.updateModels());
        this.modelSelect?.addEventListener('change', () => this.updateYears());
        this.yearSelect?.addEventListener('change', () => this.updateDestination());
        this.letterButtons.forEach((button) => button.addEventListener('click', () => this.setLetter(button)));
        this.grid?.addEventListener('click', (event) => this.selectBrandFromCard(event));
        this.setOptions(this.makeSelect, this.records, 'makeKey', 'make', this.dataset.makePlaceholder);
        this.updateModels();
        this.filter();
        this.observeCatalogEnd();
      }

      readCatalog() {
        const source = this.querySelector('[data-boat-brand-catalog]');
        if (!source) return [];
        try {
          return JSON.parse(source.textContent);
        } catch (error) {
          return [];
        }
      }

      readProductCatalog() {
        const sources = Array.from(this.querySelectorAll('[data-fitment-product-catalog-part]'));
        if (!sources.length) return [];
        try {
          return sources.flatMap((source) => JSON.parse(source.textContent)).map((record) => ({
            makeKey: record.makeKey,
            make: record.make,
            modelKey: record.modelKey,
            model: record.model,
            yearKey: record.yearKey,
            year: record.yearLabel,
            url: record.url
          }));
        } catch (error) {
          return [];
        }
      }

      renderCatalog() {
        this.renderNextBatch();
      }

      renderNextBatch() {
        if (!this.grid || this.renderedCount >= this.brands.length) return;
        const fragment = document.createDocumentFragment();
        const nextBrands = this.brands.slice(this.renderedCount, this.renderedCount + this.batchSize);
        nextBrands.forEach((brand) => fragment.append(this.createBrandCard(brand)));
        this.grid.append(fragment);
        this.renderedCount += nextBrands.length;
        this.refreshCards();
        if (this.sentinel) this.sentinel.hidden = this.renderedCount >= this.brands.length;
      }

      createBrandCard(brand) {
          const makeKey = this.keyFor(brand.name);
          const override = this.overrideByMake.get(makeKey);
          const hasCollection = !this.collectionUnavailable.has(makeKey);
          const availability = hasCollection ? 'ready' : (override?.availability || 'custom');
          const model = hasCollection ? this.dataset.viewModelsLabel : (override?.model || this.dataset.customLabel);
          const year = hasCollection ? this.dataset.allYearsLabel : (override?.year || this.dataset.allYearsLabel);
          const status = availability === 'ready' ? this.dataset.readyLabel : (override?.statusLabel || this.dataset.customLabel);
          const destination = hasCollection ? this.collectionURL(makeKey) : (override?.url || this.dataset.customProjectPage);
          const imageURL = this.optimizedImageURL(override?.image || brand.image);
          const card = document.createElement('a');
          card.className = 'pbf__card';
          card.href = destination;
          card.setAttribute('role', 'listitem');
          card.dataset.fitmentCard = '';
          card.dataset.brandKey = makeKey;
          card.dataset.brandName = brand.name.toLocaleLowerCase();
          card.dataset.brandLetter = brand.name.slice(0, 1).toLocaleLowerCase();
          card.dataset.searchValue = `${brand.name} ${model} ${year}`.toLocaleLowerCase();
          card.dataset.recordMake = brand.name;
          card.dataset.recordModel = model;
          card.dataset.recordYear = year;
          card.dataset.availability = availability;
          card.innerHTML = `
            <span class="pbf__media"><img src="${this.escapeHTML(imageURL)}" alt="${this.escapeHTML(brand.name)} custom boat kits" width="600" height="450" loading="lazy" decoding="async" fetchpriority="low"></span>
            <span class="pbf__shade"></span>
            <span class="pbf__status pbf__status--${this.escapeHTML(availability)}">${this.escapeHTML(status)}</span>
            <span class="pbf__card-copy"><strong>${this.escapeHTML(brand.name)}</strong><span>${this.escapeHTML(availability === 'ready' ? model : this.dataset.viewModelsLabel)}</span></span>
            <span class="pbf__arrow"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>
          `;
          return card;
      }

      recordForBrand(brand) {
        const makeKey = this.keyFor(brand.name);
        const override = this.overrideByMake.get(makeKey);
        const hasCollection = !this.collectionUnavailable.has(makeKey);
        const model = hasCollection ? this.dataset.viewModelsLabel : (override?.model || this.dataset.customLabel);
        const year = hasCollection ? this.dataset.allYearsLabel : (override?.year || this.dataset.allYearsLabel);
        return {
          makeKey,
          make: brand.name,
          modelKey: override?.modelKey || this.keyFor(model),
          model,
          yearKey: override?.yearKey || this.keyFor(year),
          year,
          url: hasCollection ? this.collectionURL(makeKey) : (override?.url || this.dataset.customProjectPage)
        };
      }

      collectionURL(makeKey) {
        return `/collections/${encodeURIComponent(makeKey)}-custom-eva-foam-boat-flooring`;
      }

      refreshCards() {
        this.cards = Array.from(this.querySelectorAll('[data-fitment-card]'));
      }

      ensureAllRendered() {
        if (this.renderedCount >= this.brands.length) return;
        const batchSize = this.batchSize;
        this.batchSize = this.brands.length - this.renderedCount;
        this.renderNextBatch();
        this.batchSize = batchSize;
      }

      observeCatalogEnd() {
        if (!this.sentinel || this.renderedCount >= this.brands.length) return;
        if (!('IntersectionObserver' in window)) {
          this.ensureAllRendered();
          return;
        }
        this.catalogObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.renderNextBatch();
          if (this.renderedCount >= this.brands.length) this.catalogObserver.disconnect();
        }, { rootMargin: '600px 0px' });
        this.catalogObserver.observe(this.sentinel);
      }

      selectBrandFromCard(event) {
        const card = event.target.closest('[data-fitment-card]');
        if (!card || card.dataset.availability === 'ready' || !this.makeSelect) return;
        event.preventDefault();
        this.makeSelect.value = card.dataset.brandKey;
        this.updateModels();
        this.querySelector('.pbf__finder-card')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      optimizedImageURL(value) {
        try {
          const url = new URL(value, document.baseURI);
          if (url.hostname.includes('shopify') || url.pathname.includes('/cdn/shop/')) url.searchParams.set('width', '600');
          return url.href;
        } catch (error) {
          return value;
        }
      }

      escapeHTML(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      keyFor(value) {
        return String(value || '')
          .toLocaleLowerCase()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '');
      }

      setOptions(select, records, keyName, labelName, placeholder) {
        if (!select) return 0;
        const options = new Map();
        records.forEach((record) => {
          if (record[keyName]) options.set(record[keyName], record[labelName]);
        });
        select.replaceChildren();
        const placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = placeholder;
        select.append(placeholderOption);
        Array.from(options.entries()).sort((a, b) => a[1].localeCompare(b[1])).forEach(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          select.append(option);
        });
        select.disabled = options.size === 0;
        return options.size;
      }

      updateModels() {
        const makeKey = this.makeSelect?.value || '';
        const matching = this.records.filter((record) => record.makeKey === makeKey);
        const modelCount = this.setOptions(this.modelSelect, matching, 'modelKey', 'model', this.dataset.modelPlaceholder);
        this.setOptions(this.yearSelect, [], 'yearKey', 'year', this.dataset.yearPlaceholder);
        if (!makeKey || !matching.length) return this.setDestination();
        if (modelCount === 1) {
          this.modelSelect.value = matching[0].modelKey;
          this.updateYears();
        } else {
          this.setDestination();
        }
      }

      updateYears() {
        const makeKey = this.makeSelect?.value || '';
        const modelKey = this.modelSelect?.value || '';
        const matching = this.records.filter((record) => record.makeKey === makeKey && record.modelKey === modelKey);
        const yearCount = this.setOptions(this.yearSelect, matching, 'yearKey', 'year', this.dataset.yearPlaceholder);
        if (!modelKey || !matching.length) return this.setDestination();
        if (yearCount === 1) {
          this.yearSelect.value = matching[0].yearKey;
          this.setDestination(matching[0]);
        } else {
          this.setDestination();
        }
      }

      updateDestination() {
        const makeKey = this.makeSelect?.value || '';
        const modelKey = this.modelSelect?.value || '';
        const yearKey = this.yearSelect?.value || '';
        this.setDestination(this.records.find((item) => item.makeKey === makeKey && item.modelKey === modelKey && item.yearKey === yearKey));
      }

      setDestination(record) {
        if (!this.go) return;
        this.go.href = record?.url || '#';
        this.go.setAttribute('aria-disabled', String(!record?.url));
      }

      setLetter(button) {
        this.activeLetter = button.dataset.fitmentLetter;
        this.letterButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.ensureAllRendered();
        this.filter();
      }

      filter() {
        const query = this.search?.value.trim().toLocaleLowerCase() || '';
        const matchingKeys = new Set(this.records.filter((record) => {
          const searchValue = `${record.make} ${record.model} ${record.year}`.toLocaleLowerCase();
          const matchesSearch = searchValue.includes(query);
          const matchesLetter = this.activeLetter === 'all' || record.make.slice(0, 1).toLocaleLowerCase() === this.activeLetter;
          return matchesSearch && matchesLetter;
        }).map((record) => record.makeKey));
        this.cards.forEach((card) => {
          card.hidden = !matchingKeys.has(card.dataset.brandKey);
        });
        if (this.count) this.count.textContent = this.dataset.countTemplate.replace('__COUNT__', String(matchingKeys.size));
        if (this.empty) this.empty.hidden = matchingKeys.size !== 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marine-mat-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marine-mat-configurator')) {
    customElements.define('marine-mat-configurator', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.step = 0;
        this.zoom = 1;
        this.tabs = Array.from(this.querySelectorAll('[data-step-target]'));
        this.panels = Array.from(this.querySelectorAll('[data-step-panel]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.addButton = this.querySelector('[data-add-to-cart]');
        this.progress = this.querySelector('[data-step-progress]');
        this.partialFields = this.querySelector('[data-partial-fields]');
        this.productForm = this.querySelector('.mmc__product-form');
        this.quoteForm = this.querySelector('.mmc__quote-form');
        this.status = this.querySelector('[data-config-status]');
        this.piecesInput = this.querySelector('[data-pieces]');
        this.dimensionsFile = this.querySelector('[data-dimensions-file]');
        this.dimensionsFileName = this.querySelector('[data-dimensions-file-name]');
        this.summaryFile = this.querySelector('[data-summary-file]');
        this.selectedPieces = new Set();
        this.querySelectorAll('[data-option-group]').forEach((button) => {
          button.addEventListener('click', () => this.selectOption(button));
        });
        this.querySelectorAll('[data-piece-select]').forEach((button) => {
          button.addEventListener('click', () => this.togglePiece(button));
        });
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            if (index === this.tabs.length - 1 && !this.validateDimensions()) return;
            this.activateStep(index);
          });
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });
        this.previousButton?.addEventListener('click', () => this.activateStep(this.step - 1));
        this.nextButton?.addEventListener('click', () => this.advanceStep());
        this.querySelector('[data-reset]')?.addEventListener('click', () => this.resetConfiguration());
        this.quoteForm?.addEventListener('submit', (event) => this.validateQuote(event));
        this.productForm?.addEventListener('submit', (event) => this.validateProduct(event));
        this.addButton?.addEventListener('click', (event) => this.validateProduct(event));
        this.dimensionsFile?.addEventListener('change', () => this.syncDimensionsFile());
        this.querySelectorAll('[data-boat-field]').forEach((input) => input.addEventListener('input', () => this.syncQuote()));
        this.querySelector('[data-pieces]')?.addEventListener('input', () => this.syncQuote());
        this.querySelectorAll('[data-zoom]').forEach((button) => button.addEventListener('click', () => this.setZoom(button.dataset.zoom)));
        this.initializeBoatFields();
        this.initializeDerivedPreview();
        const isExactVisualBrand = this.dataset.exactVisualBrand === 'true';
        if (isExactVisualBrand) this.dataset.finishTouched = 'false';
        this.defaultPreviewValues = {
          top: isExactVisualBrand ? '#757b81' : '#66717a',
          bottom: isExactVisualBrand ? '#000000' : '#17191b',
          design: 'inset-border',
          surface: 'brushed',
          laser: 'none',
          kit: 'complete'
        };
        this.dataset.top = this.defaultPreviewValues.top;
        this.dataset.bottom = this.defaultPreviewValues.bottom;
        if (isExactVisualBrand) {
          const topButton = this.querySelector(`[data-option-group="top"][data-option-value="${this.defaultPreviewValues.top}"]`);
          const bottomButton = this.querySelector(`[data-option-group="bottom"][data-option-value="${this.defaultPreviewValues.bottom}"]`);
          if (topButton?.dataset.optionImage) this.style.setProperty('--mmc-top-image', `url("${topButton.dataset.optionImage}")`);
          if (bottomButton?.dataset.optionImage) this.style.setProperty('--mmc-bottom-image', `url("${bottomButton.dataset.optionImage}")`);
        }
        this.updateDefaultPreviewState();
        this.activateStep(0);
        this.syncLaserAvailability(this.dataset.surface || 'brushed');
        this.syncDimensionsFile();
        this.syncQuote();
      }

      initializeBoatFields() {
        const make = String(this.dataset.selectedMake || '').trim();
        const fitment = String(this.dataset.selectedFitment || '').trim();
        const yearMatch = fitment.match(/^((?:19|20)\d{2}(?:-(?:19|20)\d{2})?)\b\s*/);
        const year = yearMatch ? yearMatch[1] : 'All supported years';
        let model = yearMatch ? fitment.slice(yearMatch[0].length).trim() : fitment;
        if (make && model.toLocaleLowerCase().startsWith(make.toLocaleLowerCase())) model = model.slice(make.length).trim();
        const makeInput = this.querySelector('[data-boat-field="manufacturer"]');
        const modelInput = this.querySelector('[data-boat-field="model"]');
        const yearInput = this.querySelector('[data-boat-field="year"]');
        if (makeInput) makeInput.value = make;
        if (modelInput) modelInput.value = model || fitment;
        if (yearInput) yearInput.value = year;
      }

      initializeDerivedPreview() {
        const deck = this.querySelector('[data-derived-source]');
        const source = deck?.querySelector('[data-product-deck-source]');
        const outline = deck?.querySelector('[data-derived-outline]');
        if (!deck || !source || !outline || !source.dataset.src) return;
        source.crossOrigin = 'anonymous';
        source.addEventListener('load', () => {
          const longEdge = Math.max(source.naturalWidth, source.naturalHeight);
          const scale = Math.min(1, 1600 / longEdge);
          const width = Math.max(1, Math.round(source.naturalWidth * scale));
          const height = Math.max(1, Math.round(source.naturalHeight * scale));
          const sourceCanvas = document.createElement('canvas');
          sourceCanvas.width = width;
          sourceCanvas.height = height;
          const sourceContext = sourceCanvas.getContext('2d', { willReadFrequently: true });
          sourceContext.drawImage(source, 0, 0, width, height);
          const sourcePixels = sourceContext.getImageData(0, 0, width, height);
          const maskCanvas = document.createElement('canvas');
          maskCanvas.width = width;
          maskCanvas.height = height;
          const maskContext = maskCanvas.getContext('2d');
          const maskPixels = maskContext.createImageData(width, height);
          outline.width = width;
          outline.height = height;
          const outlineContext = outline.getContext('2d');
          const outlinePixels = outlineContext.createImageData(width, height);
          for (let index = 0; index < sourcePixels.data.length; index += 4) {
            const red = sourcePixels.data[index];
            const green = sourcePixels.data[index + 1];
            const blue = sourcePixels.data[index + 2];
            const luma = red * .2126 + green * .7152 + blue * .0722;
            const maskAlpha = Math.max(0, Math.min(255, (248 - luma) * 4.4));
            const outlineAlpha = Math.max(0, Math.min(255, (130 - luma) * 5.1));
            maskPixels.data[index] = 255;
            maskPixels.data[index + 1] = 255;
            maskPixels.data[index + 2] = 255;
            maskPixels.data[index + 3] = maskAlpha;
            outlinePixels.data[index] = 20;
            outlinePixels.data[index + 1] = 23;
            outlinePixels.data[index + 2] = 26;
            outlinePixels.data[index + 3] = outlineAlpha;
          }
          maskContext.putImageData(maskPixels, 0, 0);
          outlineContext.putImageData(outlinePixels, 0, 0);
          deck.style.setProperty('--mmc-product-mask-image', `url("${maskCanvas.toDataURL('image/png')}")`);
          deck.dataset.derivedReady = 'true';
        }, { once: true });
        source.addEventListener('error', () => deck.dataset.derivedError = 'true', { once: true });
        source.src = source.dataset.src;
      }

      selectOption(button) {
        const group = button.dataset.optionGroup;
        this.querySelectorAll(`[data-option-group="${group}"]`).forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        const value = button.dataset.optionValue;
        const label = button.dataset.optionLabel;
        const image = button.dataset.optionImage;
        this.dataset[group] = value;
        if (group === 'top' || group === 'bottom') this.dataset[`${group}Color`] = value;
        this.style.setProperty(`--mmc-${group}-color`, value);
        if (group === 'top') {
          this.style.setProperty('--mmc-top', value);
          this.style.setProperty('--mmc-top-image', this.dataset.exactVisualBrand === 'true' && image ? `url("${image}")` : 'none');
        }
        if (group === 'bottom') {
          this.style.setProperty('--mmc-bottom', value);
          this.style.setProperty('--mmc-bottom-image', this.dataset.exactVisualBrand === 'true' && image ? `url("${image}")` : 'none');
        }
        if (group === 'surface') this.syncLaserAvailability(value);
        const property = this.querySelector(`[data-property="${group}"]`);
        if (property) property.value = label;
        const summary = this.querySelector(`[data-summary="${group}"]`);
        if (summary) summary.textContent = label;
        const previewLabel = this.querySelector(`[data-preview-label="${group}"]`);
        if (previewLabel) previewLabel.textContent = label;
        if (group === 'kit') this.updateKit(value);
        this.updateDefaultPreviewState();
        this.syncQuote();
      }

      updateDefaultPreviewState() {
        const defaults = this.defaultPreviewValues || {
          top: '#66717a',
          bottom: '#17191b',
          design: 'inset-border',
          surface: 'brushed',
          laser: 'none',
          kit: 'complete'
        };
        const isDefault = Object.entries(defaults).every(([group, value]) => String(this.dataset[group] || '').toLowerCase() === String(value).toLowerCase());
        this.dataset.defaultPreview = String(isDefault);
      }

      syncLaserAvailability(surface) {
        const buttons = Array.from(this.querySelectorAll('[data-option-group="laser"][data-compatible-surface]'));
        buttons.forEach((button) => {
          const compatible = button.dataset.compatibleSurface === surface;
          button.hidden = !compatible;
          button.disabled = !compatible;
          button.setAttribute('aria-disabled', String(!compatible));
        });
        const selected = buttons.find((button) => button.getAttribute('aria-pressed') === 'true' && button.disabled);
        const none = this.querySelector('[data-option-group="laser"][data-option-value="none"]');
        if (selected && none) this.selectOption(none);
      }

      updateKit(value) {
        const partial = value === 'partial';
        if (this.partialFields) this.partialFields.hidden = !partial;
        if (this.piecesInput) this.piecesInput.required = partial;
        if (this.addButton && this.step === 5) this.addButton.hidden = partial;
      }

      togglePiece(button) {
        const piece = button.dataset.pieceSelect;
        if (this.selectedPieces.has(piece)) this.selectedPieces.delete(piece);
        else this.selectedPieces.add(piece);
        const selected = this.selectedPieces.has(piece);
        button.setAttribute('aria-pressed', String(selected));
        const highlight = this.querySelector(`[data-piece-highlight="${piece}"]`);
        if (highlight) highlight.dataset.selected = String(selected);
        if (this.piecesInput) {
          this.piecesInput.value = Array.from(this.selectedPieces).sort((left, right) => Number(left) - Number(right)).join(', ');
        }
        this.syncQuote();
      }

      clearPieceSelection() {
        this.selectedPieces.clear();
        this.querySelectorAll('[data-piece-select]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
        this.querySelectorAll('[data-piece-highlight]').forEach((highlight) => highlight.dataset.selected = 'false');
        if (this.piecesInput) this.piecesInput.value = '';
      }

      validateQuote(event) {
        const requiredFields = [...this.querySelectorAll('[data-boat-field]'), this.piecesInput].filter(Boolean);
        const invalidField = requiredFields.find((input) => !input.checkValidity());
        if (!invalidField) return;
        event.preventDefault();
        invalidField.reportValidity();
      }

      syncDimensionsFile() {
        const file = this.dimensionsFile?.files?.[0];
        if (this.dimensionsFile) {
          this.dimensionsFile.setCustomValidity('');
          this.dimensionsFile.setAttribute('aria-invalid', 'false');
        }
        const selectedMessage = file
          ? String(this.dataset.fileSelectedMessage || '').replace('__FILENAME__', file.name)
          : this.dataset.fileRequiredMessage;
        if (this.dimensionsFileName) this.dimensionsFileName.textContent = selectedMessage;
        if (this.summaryFile) this.summaryFile.textContent = selectedMessage;
      }

      validateDimensions() {
        if (!this.dimensionsFile || this.dimensionsFile.files.length > 0) {
          if (this.dimensionsFile) {
            this.dimensionsFile.setCustomValidity('');
            this.dimensionsFile.setAttribute('aria-invalid', 'false');
          }
          return true;
        }
        this.dimensionsFile.setCustomValidity(this.dataset.fileRequiredMessage || 'Upload a boat dimensions drawing before continuing.');
        this.dimensionsFile.setAttribute('aria-invalid', 'true');
        this.activateStep(5);
        requestAnimationFrame(() => this.dimensionsFile.reportValidity());
        return false;
      }

      validateProduct(event) {
        if (this.validateDimensions()) return true;
        event.preventDefault();
        event.stopPropagation();
        return false;
      }

      advanceStep() {
        if (this.step === 0) {
          const invalidField = Array.from(this.querySelectorAll('[data-boat-field]')).find((input) => !input.checkValidity());
          if (invalidField) {
            invalidField.reportValidity();
            return;
          }
        }
        if (this.step === 5 && !this.validateDimensions()) return;
        this.activateStep(this.step + 1);
      }

      resetConfiguration() {
        this.productForm?.reset();
        this.quoteForm?.reset();
        const defaults = this.defaultPreviewValues || {
          top: '#66717a',
          bottom: '#17191b',
          design: 'inset-border',
          surface: 'brushed',
          laser: 'none',
          kit: 'complete'
        };
        Object.entries(defaults).forEach(([group, value]) => {
          const button = this.querySelector(`[data-option-group="${group}"][data-option-value="${value}"]`);
          if (button) this.selectOption(button);
        });
        this.clearPieceSelection();
        this.activateStep(0);
        if (this.dataset.exactVisualBrand === 'true') this.dataset.finishTouched = 'false';
        this.updateDefaultPreviewState();
        this.setZoom('reset');
        this.initializeBoatFields();
        this.syncDimensionsFile();
        this.syncQuote();
        if (this.status) this.status.textContent = this.dataset.resetMessage;
      }

      activateStep(index) {
        this.step = Math.max(0, Math.min(index, this.tabs.length - 1));
        if (this.dataset.exactVisualBrand === 'true' && this.step === 3) this.dataset.finishTouched = 'true';
        this.dataset.step = String(this.step);
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === this.step;
          tab.setAttribute('aria-selected', String(selected));
          tab.dataset.complete = String(tabIndex < this.step);
          tab.tabIndex = selected ? 0 : -1;
        });
        const progressValue = this.step + 1;
        this.style.setProperty('--mmc-progress', `${(progressValue / this.tabs.length) * 100}%`);
        if (this.progress) this.progress.setAttribute('aria-valuenow', String(progressValue));
        this.panels.forEach((panel, panelIndex) => panel.hidden = panelIndex !== this.step);
        if (this.previousButton) this.previousButton.hidden = this.step === 0;
        if (this.nextButton) this.nextButton.hidden = this.step === this.tabs.length - 1;
        if (this.addButton) this.addButton.hidden = this.step !== this.tabs.length - 1 || this.dataset.kit === 'partial';
      }

      onTabKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let target = index;
        if (event.key === 'ArrowLeft') target = index - 1;
        if (event.key === 'ArrowRight') target = index + 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.tabs.length - 1;
        target = (target + this.tabs.length) % this.tabs.length;
        this.activateStep(target);
        this.tabs[target].focus();
      }

      setZoom(action) {
        if (action === 'in') this.zoom = Math.min(1.32, this.zoom + 0.08);
        if (action === 'out') this.zoom = Math.max(0.84, this.zoom - 0.08);
        if (action === 'reset') this.zoom = 1;
        this.style.setProperty('--mmc-zoom', this.zoom);
      }

      syncQuote() {
        this.querySelectorAll('[data-boat-field]').forEach((input) => {
          const quote = this.querySelector(`[data-quote-field="${input.dataset.boatField}"]`);
          if (quote) quote.value = input.value;
        });
        this.querySelectorAll('[data-property]').forEach((input) => {
          const quote = this.querySelector(`[data-quote-option="${input.dataset.property}"]`);
          if (quote) quote.value = input.value;
        });
        const pieces = this.querySelector('[data-pieces]');
        const quotePieces = this.querySelector('[data-quote-pieces]');
        if (pieces && quotePieces) quotePieces.value = pieces.value;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
